import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const HotelWifiSettingsComponent = lazy(
  () => import('./hotel-wifi-settings.tsx')
);

export const hotelWifiSettingsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <HotelWifiSettingsComponent />
      </Suspense>
    )
  }
];
